import React, { useEffect } from 'react'

import { Modal } from 'antd'
import { useDeleteSubscrptionMutation } from '../../services/subscrption/subscrption.service' 
import { useNavigate, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'

export const ConfirmDeleteSubscrpition = ({ visible, title, onCancel, okText, user }) => {

    const navigate = useNavigate()
    const [deleteSubscrption, { data, isLoading, isSuccess, isError, error }] = useDeleteSubscrptionMutation()
    const {settingId}=useParams()
    const id=settingId
   
    const handleOk = () => {
        deleteSubscrption(id)
    }

    useEffect (() => {
        if(isSuccess && data){
            toast.success("User Deleted Successfully!")
            setTimeout(() => {
                onCancel()
                    navigate('/Subscrption') 
                
            }, 3000);
        }
    })

    return (
        <Modal
            visible={visible}
            title={title}
            onOk={handleOk}
            onCancel={onCancel}
            okText={okText}
            className='user_modal_style'
            confirmLoading={isLoading}
        >

            {
                isError &&
                <div className='flex mt-3'>
                    <p className='text-red-500 text-md font-bold mx-3'>
                        {error?.name || error?.status}
                    </p>
                    <p className='text-red-500 text-md font-bold'>
                        {error?.message || error?.data.message}
                    </p>
                </div>
            }

            <p>
                Are you sure, you want to delete {user?.subTitle}
            </p>
            <p>This will be deleted so soon</p>
        </Modal>
    )
}
